<template>
    <div class="container">
        <div class="handle-box-search">
            <div class="handle-box">
                <el-row class="head-search">
                    <el-col :span="12" style="margin-top: 10px">
                        <span class="title">创建时间:</span>

                        <el-date-picker
                            v-model="search_time"
                            type="datetimerange"
                            range-separator="-"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            @change="timeChange"
                            style="width: 350px"
                        >
                        </el-date-picker>
                    </el-col>
                    <el-col :span="12">
                        <span class="title">优惠卡名称:</span>
                        <!-- 搜索优惠卡名称 -->
                        <el-input
                            v-model="search_data.name"
                            placeholder="请输入优惠卡名称"
                            class="handle-input mr10"
                            @keyup.enter.native="searchOfflineDiscountCardLogLists"
                        ></el-input>
                    </el-col>
                    
                    
                </el-row>
                
                <el-row class="head-search">
                    <el-col :span="12" style="margin-top: 10px">
                        <span class="title">使用时间:</span>

                        <el-date-picker
                            v-model="search_time_use"
                            type="datetimerange"
                            range-separator="-"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            @change="timeChangeUse"
                            style="width: 350px"
                        >
                        </el-date-picker>
                    </el-col>
                    <el-col :span="12">
                        <span class="title">优惠卡编码:</span>
                        <!-- 搜索优惠卡编码 -->
                        <el-input
                            v-model="search_data.card_code"
                            placeholder="请输入优惠卡编码"
                            class="handle-input mr10"
                            @keyup.enter.native="searchOfflineDiscountCardLogLists"
                        ></el-input>
                    </el-col>
                    
                    
                </el-row>
                <el-row class="head-search">
                    <el-col :span="12">
                        <span class="title">订单编号:</span>
                        <!-- 搜索单号 -->
                        <el-input
                            v-model="search_data.billno"
                            placeholder="请输入订单编号"
                            class="handle-input mr10"
                            @keyup.enter.native="searchOfflineDiscountCardLogLists"
                        ></el-input>
                    </el-col>
                    
                </el-row>
            </div>

            <el-button type="primary" icon="el-icon-search" @click="searchOfflineDiscountCardLogLists">搜索</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
 
        </div>
        <el-table
            :data="tableData"
            class="table"
            ref="multipleTable"
            header-cell-class-name="table-header"
          
        >
            <el-table-column type="selection" width="55" disabled> </el-table-column>
            <el-table-column label="优惠卡名称" prop="name"> </el-table-column>
            <el-table-column label="编码" prop="card_code"> </el-table-column>
            <el-table-column label="创建时间" prop="time.YmdHis"> </el-table-column>
            <el-table-column label="优惠金额" prop="amount"> </el-table-column>
            <el-table-column label="线下支付" prop="offline_pay.alias"> </el-table-column>
            <el-table-column label="模式" prop="order_mode.name"> </el-table-column>
            <el-table-column label="到期时间" prop="expire_time"> </el-table-column>
            <el-table-column label="状态" prop="type.alias"> </el-table-column>
            <el-table-column label="使用时间" prop="use.YmdHis"> </el-table-column>
            <el-table-column label="订单编号" prop="billno"> </el-table-column>
            <el-table-column label="使用人" prop="consumer_mobile"> </el-table-column>

        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>
  
      
    </div>
</template>

<script>
var _this;

export default {
  
    data() {
        return {

            add_isShow: false,
            search_time: '',
            search_time_use: '',
      
            card_code: '',
            srcList: [],
            card_code: [],

            // 存放表格数据
            tableData: [],

            //获取用户列表的数据
            search_data: {
                page: 1,
                limit: 10,
                name: '',
                card_code: '',
                created_at: '',
                billno: '',
                use_time: '',
            },

            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        _this.searchOfflineDiscountCardLogLists();
    },

    methods: {
        timeChange(val) {
            console.log(val);

            if (val != null) {
                _this.search_data.created_at = JSON.stringify(['between', ..._this.search_time]);
            } else {
                _this.search_data.created_at = '';
            }
        },
        timeChangeUse(val) {
            console.log(val);

            if (val != null) {
                _this.search_data.use_time = JSON.stringify(['between', ..._this.search_time_use]);
            } else {
                _this.search_data.use_time = '';
            }
        },
        offlineDiscountCardLogLists() {
            console.log(333);
            _this
                .$post('/offlinediscountcard/offlineDiscountCardLogLists', _this.search_data, _this.search_rules)
                .then((res) => {
                  
                    _this.tableData = res.data;

                    _this.result_data = res;
                    _this.srcList.length = 0;
                   
                })
                .catch((err) => {});
        },



        searchOfflineDiscountCardLogLists() {
            _this.search_data.page = 1;
            _this.offlineDiscountCardLogLists();
        },

        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.offlineDiscountCardLogLists();
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 350px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>
